var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStudentManage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4166 19.5833V15H26.6666V19.5833C26.6666 19.9285 26.3868 20.2083 26.0416 20.2083C25.6965 20.2083 25.4166 19.9285 25.4166 19.5833Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 18.333V15.833H16.6666V18.333C16.6666 20.1739 18.159 21.6663 20 21.6663C21.8409 21.6663 23.3333 20.1739 23.3333 18.333Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3569 14.6191L18.9849 12.1178C19.6313 11.8305 20.3692 11.8305 21.0156 12.1178L26.6435 14.6191C26.9735 14.7658 26.9735 15.234 26.6435 15.3806L21.0156 17.882C20.3692 18.1692 19.6313 18.1692 18.9849 17.882L13.3569 15.3806C13.027 15.234 13.027 14.7658 13.3569 14.6191Z",
    fill: "#6B7280"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9163 22.8331L20.5924 24.1717C20.2663 24.5015 19.7336 24.5015 19.4074 24.1717L18.0836 22.8331C17.8791 22.6264 17.5806 22.5382 17.3016 22.6203C14.964 23.3077 13.3333 24.8609 13.3333 26.6669C13.3333 27.5873 14.0794 28.3335 14.9999 28.3335H24.9999C25.9204 28.3335 26.6666 27.5873 26.6666 26.6669C26.6666 24.8609 25.0358 23.3077 22.6983 22.6203C22.4193 22.5382 22.1207 22.6264 21.9163 22.8331Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStudentManage);
export default __webpack_public_path__ + "static/media/ic_student_manage.7249809c70ae4bfaada6591a07594c05.svg";
export { ForwardRef as ReactComponent };